import montserrat from '../../fonts/montserrat';
import openDyslexic from '../../fonts/openDyslexic';
import openSans from '../../fonts/openSans';
import quicksand from '../../fonts/quicksand';
const fonts = [montserrat, openDyslexic, openSans, quicksand];

export interface FontFace {
  name: string;
  variant: 'Regular' | 'Light' | 'Bold';
  ttfUrl: string;
  woffUrl: string;
  woff2Url: string;
}
export const makeFontFace = (params: FontFace) => {
  return `
    @font-face {
      font-family: ${params.name};
      font-style: normal;
      font-weight: ${
        params.variant === 'Light'
          ? 300
          : params.variant === 'Regular'
          ? 400
          : params.variant === 'Bold'
          ? 500
          : 'normal'
      };
      src: local(${params.name}-${params.variant}), url(${
    params.woff2Url
  }) format('woff2'),
      url(${params.woffUrl}) format('woff'),
      url(${params.ttfUrl})  format('truetype');
      unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    }
         `;
};

export const fontFacesCss = fonts.map(makeFontFace);
